import { CasinoMenuActionsBootstrapService } from '@casinocore/platform';
import { CoordinatorBootstrapperService } from '@casinocore/platform/core';
import { InstagramSectionService } from '@casinocore/platform/gaming-stories';

import { BingoBootstrapService } from './bingo/bingo-bootstrap.service';
import { CasinoBootstrapService } from './casino-bootstrap.service';
import { GlobalSearchBootstrapService } from './global-search/global-search-bootstrap.service';
import { NativeBoostrapService } from './native/native-bootstrap.service';
import { runOnCasinoAppInit } from './run-on-casino-init.provider';

export const provideCasinoAppBootstrap = () => runOnCasinoAppInit(CasinoBootstrapService);
export const provideCasinoMenuActionsBootstrap = () => runOnCasinoAppInit(CasinoMenuActionsBootstrapService);
export const provideNativeBootstrap = () => runOnCasinoAppInit(NativeBoostrapService);
export const provideBingoBootstrap = () => runOnCasinoAppInit(BingoBootstrapService);
export const provideGlobalSearchBootstrap = () => runOnCasinoAppInit(GlobalSearchBootstrapService);
export const provideGeoCoordinator = () => runOnCasinoAppInit(CoordinatorBootstrapperService);
export const provideCasinoInstaSection = () => runOnCasinoAppInit(InstagramSectionService);
